import React, { useEffect, useState } from "react";
import { Container, Row, Col, Tabs, Tab, Card } from "react-bootstrap";
import './About.scss';
import bannerAboutUs from "./../../assets/images/about/Imagen banner  1080 x 781.png";
import Chat from "./../../assets/images/about/picto-conversación.svg";
import LOGRAR from "./../../assets/images/about/teams.png";
import CULTURA from "./../../assets/images/about/cultura.jpg";
import Somos from "./../../assets/images/about/Quienes somos.jpg";

import { ReactComponent as DownloadIcon } from './../../assets/images/Icons_descargar.svg'
import { useLocation } from "react-router-dom";

interface ItemTabProps {
  list: string[];
  last: boolean;
}

const ItemTab: React.FC<ItemTabProps> = ({ list, last }) => {
  return (
    <ul style={{ borderBottomStyle: 'solid', borderBottomColor: '#cccccc', paddingTop: 16, paddingBottom: 5, paddingLeft: 20, borderBottomWidth: last ? 0 : 2 }}>
      {list.map((item) => (
        <li key={item} className={'list-tab-item'} style={{ listStyleType: 'initial', listStylePosition: 'outside' }}>
          {item}
        </li>
      ))}
    </ul>
  );
};

interface ItemImageProps {
  image: string;
  title: React.ReactNode;
}

const ItemImage: React.FC<ItemImageProps> = ({ image, title }) => {
  return (
    <div style={{ margin: "30px 30px 30px 40px" }}>
      <div
        style={{
          backgroundColor: "#eff6f9",
          display: "flex",
          width: "244px",
          height: "98px",
          alignItems: "center",
          position: "relative",
        }}
      >
        <div style={{ position: "absolute", right: "205px" }}>
          <img src={image} alt="itemImage" />
        </div>
        {title}
      </div>
    </div>
  );
};

const AboutComponent: React.FC = () => {
  return (
    <div >
   
      <div className="boxi-about" >
        <Container>
          <div className="banner-container-banner" >
            <div className="banner-container-text">
              <span className="banner-text-banner">  <span style={{color:"#EC0000"}}>Quiénes </span>somos<br />
                <span className="banner-subText-banner">Conoce nuestra historia, valores y cómo seguimos trabajando cada día para ti.</span>
              </span>
            </div>
            <div>
              <img className="banner-image" src={bannerAboutUs} alt="Banner Nosotros" fetchPriority='high' />
            </div>
          </div>
        </Container>

      </div>
      <Container>
        <div className="container">
          
          <span className="Ptitle"  style={{color:"#EC0000"}}>
            Quiénes somos
          </span>
          <Row>
            <Col md={6}>
              <span className="parrafo" style={{ textAlign: "left" }}>
              Santander Empresa Administradora de Fondos Colectivos, forma parte del Grupo Santander, quien cuenta con más de 173 millones de clientes en el 2024, un grupo con escala global, con presencia en Europa, Norteamérica y Sudamérica.
              El Banco Santander se organiza en cinco negocios globales: Retail & Commercial Banking (Retail), Digital Consumer Bank (Consumer), Corporate & Investment Banking (CIB), Wealth Management & Insurance (Wealth) y Payments. Nuestros cinco negocios globales y nuestra presencia en Europa, DCB Europe, Norteamérica y Sudamérica apoyan la creación de valor sobre la base de un crecimiento rentable y el apalancamiento operativo que proporciona ONE Santander.              </span>
              <br />
               <br />
              
             
            </Col>

            <Col md={6}>
              <img
                style={{
                  width: "100%",
                  position: "relative",
                  objectFit: "cover"
                }}
                className="w-100 h-80"
                src={Somos}
                alt="First slide"
              />
            </Col>
          </Row>
        </div>

  
           <div className="container" style={{ marginBottom: "80px" }}>
           <span className="Ptitle">
                Grupo Santander
              </span>
              
              <p>
                <span className="parrafo">
                Unidos por una cultura global común, The Santander Way, el cual abarca:
                </span>
              </p>
          <Row>
            <Col md={4} style={{ padding:"20px 60px"}}>
              <span className="subtitle_form"  style={{  textAlign:"center"}}>
                Nuestra misión
              </span>
              <hr style={{ color:"turquoise" }}/>
              
                <span className="parrafo">
                  
                </span>
              

          

              <p>
                <span className="parrafo">
                 Contribuir al progreso de las personas y empresas
                </span>
              </p>
              
            </Col>
            <Col md={4} style={{ padding:"20px 60px",}}>
              <span className="subtitle_form" style={{  textAlign:"center"}}>
                Nuestra visión
              </span>
              <hr style={{ color:"turquoise" }}/>
              
                <span className="parrafo">
                  
                </span>
              

          

              <p>
                <span className="parrafo">
                 Ser la mejor plataforma abierta de servicios financieros, actuando de forma responsable y ganándonos la confianza de nuestros empleados, clientes, accionista y de la sociedad
                </span>
              </p>
              
            </Col>
              <Col md={4} style={{ padding:"20px 60px"}}>
              <span className="subtitle_form" style={{  textAlign:"center"}}>
                Cómo hacemos las cosas
              </span>
              <hr style={{ color:"turquoise" }}/>
              
                <span className="parrafo">
                  
                </span>
              

          

              <p>
                <span className="parrafo">
                Todo lo que hacemos debe ser <br/> <strong> Sencillo</strong>,<strong> Personal</strong> y <strong>Justo</strong>
                </span>
              </p>
              
            </Col>
          </Row>
        </div> 
      
        <div className="container" >
          
          <div >
            
          </div>

        
            <Col md={12} style={{ paddingBottom: "24px" }}>
              <span className="valores">
                Sencillo
              </span>
              <br />
              <span className="parrafo">
              Ofrecemos a los clientes un servicio accesible, con productos sencillos y fáciles de entender. Usamos un lenguaje sencillo y mejoramos nuestros procesos todos los días.
              </span>
            </Col>

            <Col md={12} style={{ paddingBottom: "24px" }}>
              <span className="valores">
                Personal
              </span>
              <br />
              <span className="parrafo">
              Tratamos a nuestros clientes de forma personalizada, ofreciéndoles los productos y servicios que mejor se adaptan a sus necesidades. Queremos que todos y cada uno de nuestros empleados y clientes se sientan valorados y tratados de forma única.
              </span>
            </Col>

            <Col md={12}>
              <span className="valores">
                Justo
              </span>
              <br />
              <span className="parrafo">
              Tratamos a nuestros empleados y clientes de forma justa y equitativa, somos transparentes y cumplimos nuestras promesas. Entablamos buenas relaciones con los diversos grupos de interés porque entendemos que lo que es bueno para ellos lo es también para Santander.
              </span>
            </Col>
         

        </div>
        <div className="container">
          <span className="Ptitle" >
            Nuestros Comportamientos
          </span>
          <Col >

<img
  alt=''
  style={{}}
  className="d-block w-100"
  src={LOGRAR}
/>
</Col>
          <Row>
            <Col >

              <span className="parrafo">
              <strong>Think Customer (Pienso en el Cliente)</strong><br/>
              
Cuido la relación con mis clientes y doy lo mejor de mí para conseguir su confianza y fidelidad.

              </span><br/>
              <span className="parrafo">
        <strong>Embrace Change (Impulso el Cambio)</strong><br/>
        Afronto nuevos desafíos y busco nuevas formas de hacer las cosas como una oportunidad para crecer
              </span><br/>
              <span className="parrafo">
              <strong>Act Now (Actúo con rápidez)</strong><br/>
              Tomo la iniciativa con responsabilidad, y gestiono los riesgos, haciendo siempre las cosas de manera sencilla.
              </span><br/>
              <span className="parrafo">
              <strong>Move Together (Trabajo en Equipo)</strong><br/>
              Promuevo la colaboración y trabajo junto a mis compañeros para alcanzar objetivos comunes
              </span><br/>
              <span className="parrafo">
              <strong>Speak Up (Hablo Abiertamente)</strong><br/>
              Promuevo la colaboración y trabajo junto a mis compañeros para alcanzar objetivos comunes
              </span><br/>

            </Col>
            
            <span className="Ptitle" >
            Mantenemos nuestra cultura Santander Way para continuar cumpliendo con nuestros grupos de interés:
          </span>
          <Col >
<center>
<img
  alt=''
  style={{ width:"60%"}}
  className="d-block "
  src={CULTURA}
/></center>
</Col>

          </Row>
        </div>
    
        <div className="container" id="gobierno-corporativo">
          <span className="Ptitle">
            Gobierno Corporativo
          </span>

          <Tabs
            defaultActiveKey="directorio"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="directorio" title="Directorio">
              <Row style={{ padding: 40 }}>
                <Col md={3}>
                  <p className="Columna">Directorio de Santander Empresa Administradora de Fondos Colectivos</p>
                </Col>
                <Col md={9}>
                  <span className="parrafo">
                   <strong> Carlos Américo Morante Ormeño (Presidente del Directorio)</strong><br /><br/>
A la fecha se desempeña como Head de DCB Peru de Santander, Gerente General de Santander Consumer Bank, Director General de Negocios Retail, Director suplente de Santander Consumer Perú, Director Suplente en Santander Financiamientos y Presidente de Directorio de NEOAUTO.<br /><br />Previamente ha ocupado las siguientes posiciones:  Gerente General de Santander Consumer Peru (2022-2025), CEO – Caja CENCOSUD (2018-2021) y CEO – Financiera CrediScotia (2015-2018), Gerente General en Grupo UTP (2014-2015), Gerente General en Mibanco (2012-2014) y distintas gerencias dentro del Banco de Crédito del Perú (1994-2012)<br /><br /><br />
  <strong>Victor Andres Zuñiga Flores (Director) </strong><br /><br/>
A la fecha se desempeña como Director Comercial de DCB de Santander y Gerente General de Santander Consumer Perú.

<br /><br />Previamente ha ocupado las siguientes posiciones: Gerente General de la Finaciera CrediScotia (2018-2025), además se desempeñó como Vicepresidente de Experiencia del Cliente y Ventas en Scotiabank Perú, habiendo ocupado otras posiciones gerenciales de responsabilidad al interior de Scotiabank Perú, tales como VP Red de Agencias, VP Banca de Negocios, Gerente Principal Banca de Negocios y Gerente Principal Segmento Micro y Pequeña Empresa.

<br /><br />Egresado de Ingeniería Industrial, Pontificia Universidad Católica del Perú y del MBA, Universidad del Pacífico. Con estudios en el Ivey Leadership Program de Ivey Business School, Western University de Canadá.

<br /><br /><br />
<strong>Jose Gonzalo Zúñiga Flores  (Director Independiente)</strong><br /><br/>
Economista por la Pontificia Universidad Católica del Perú con estudios complementarios en Kellogg Graduate School of Management, USA - Advanced Executive Program y un MBA por ESAN.
<br /><br /> Cuenta con más de 30 años de experiencia local e internacional en organizaciones líderes en las industrias de petróleo y gas, automotriz, mayorista, minorista, financiamiento y servicios, incluidos 23 años como gerente general (CEO) y 9 continuos como director. A la fecha se desempeña como miembro del Consejo Directivo de SNMOE (Sociedad Nacional de Minería y Energía).

<br /><br />Previamente ha ocupado la posición de Gerente General de empresas como SOLGAS S.A. (Subsidiaria de Abastible, filial de Empresas COPEC, Chile), DIVEMOTOR S.A. (Grupo Kauffmann, Chile), CORPORACION PECSA, y se ha desempeñado como Director en Grupo Gildemeister, Finanty, Mareauto, Autoland entre otros.

<br /><br />
                  </span>
                   
                  <br />
                  
                  
                </Col>
              </Row>
            </Tab>
       
          </Tabs>
        </div>

      </Container>
    </div>
  );
};

export default AboutComponent;